var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeadershipCompetencies(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 3200,
    height: 1800,
    viewBox: "0 0 3200 1800",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1705.39 479H1875.28V493H1705.39C1702.41 493 1700 489.866 1700 486C1700 482.134 1702.41 479 1705.39 479Z",
    fill: "#2D72FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2069.39 479H1894.11V493H2069.39V479Z",
    fill: "#2D72FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2266.31 479H2088.34V493H2266.31V479Z",
    fill: "#2D72FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2460.48 479H2285.2V493H2460.48V479Z",
    fill: "#2D72FE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2479.31 479H2649.2C2652.18 479 2654.59 482.134 2654.59 486C2654.59 489.866 2652.18 493 2649.2 493H2479.31V479Z",
    fill: "#2D72FE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1705.39 613H1875.28V627H1705.39C1702.41 627 1700 623.866 1700 620C1700 616.134 1702.41 613 1705.39 613Z",
    fill: "#2D72FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2069.39 613H1894.11V627H2069.39V613Z",
    fill: "#2D72FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2266.31 613H2088.34V627H2266.31V613Z",
    fill: "#2D72FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2460.48 613H2285.2V627H2460.48V613Z",
    fill: "#2D72FE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2479.31 613H2649.2C2652.18 613 2654.59 616.134 2654.59 620C2654.59 623.866 2652.18 627 2649.2 627H2479.31V613Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1705.39 747H1875.28V761H1705.39C1702.41 761 1700 757.866 1700 754C1700 750.134 1702.41 747 1705.39 747Z",
    fill: "#2D72FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2069.39 747H1894.11V761H2069.39V747Z",
    fill: "#2D72FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2266.31 747H2088.34V761H2266.31V747Z",
    fill: "#2D72FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2460.48 747H2285.2V761H2460.48V747Z",
    fill: "#2D72FE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2479.31 747H2649.2C2652.18 747 2654.59 750.134 2654.59 754C2654.59 757.866 2652.18 761 2649.2 761H2479.31V747Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1705.39 881H1875.28V895H1705.39C1702.41 895 1700 891.866 1700 888C1700 884.134 1702.41 881 1705.39 881Z",
    fill: "#2D72FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2069.39 881H1894.11V895H2069.39V881Z",
    fill: "#2D72FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2266.31 881H2088.34V895H2266.31V881Z",
    fill: "#2D72FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2460.48 881H2285.2V895H2460.48V881Z",
    fill: "#2D72FE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2479.31 881H2649.2C2652.18 881 2654.59 884.134 2654.59 888C2654.59 891.866 2652.18 895 2649.2 895H2479.31V881Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1705.39 1015H1875.28V1029H1705.39C1702.41 1029 1700 1025.87 1700 1022C1700 1018.13 1702.41 1015 1705.39 1015Z",
    fill: "#2D72FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2069.39 1015H1894.11V1029H2069.39V1015Z",
    fill: "#2D72FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2266.31 1015H2088.34V1029H2266.31V1015Z",
    fill: "#2D72FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2460.48 1015H2285.2V1029H2460.48V1015Z",
    fill: "#2D72FE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2479.31 1015H2649.2C2652.18 1015 2654.59 1018.13 2654.59 1022C2654.59 1025.87 2652.18 1029 2649.2 1029H2479.31V1015Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1705.39 1149H1875.28V1163H1705.39C1702.41 1163 1700 1159.87 1700 1156C1700 1152.13 1702.41 1149 1705.39 1149Z",
    fill: "#2D72FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2069.39 1149H1894.11V1163H2069.39V1149Z",
    fill: "#2D72FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2266.31 1149H2088.34V1163H2266.31V1149Z",
    fill: "#2D72FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2460.48 1149H2285.2V1163H2460.48V1149Z",
    fill: "#2D72FE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2479.31 1149H2649.2C2652.18 1149 2654.59 1152.13 2654.59 1156C2654.59 1159.87 2652.18 1163 2649.2 1163H2479.31V1149Z",
    fill: "#2D72FE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1705.39 1283H1875.28V1297H1705.39C1702.41 1297 1700 1293.87 1700 1290C1700 1286.14 1702.41 1283 1705.39 1283Z",
    fill: "#2D72FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2069.39 1283H1894.11V1297H2069.39V1283Z",
    fill: "#2D72FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2266.31 1283H2088.34V1297H2266.31V1283Z",
    fill: "#2D72FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2460.48 1283H2285.2V1297H2460.48V1283Z",
    fill: "#2D72FE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2479.31 1283H2649.2C2652.18 1283 2654.59 1286.13 2654.59 1290C2654.59 1293.87 2652.18 1297 2649.2 1297H2479.31V1283Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1705.39 1417.01H1875.28V1431.01H1705.39C1702.41 1431.01 1700 1427.87 1700 1424.01C1700 1420.14 1702.41 1417.01 1705.39 1417.01Z",
    fill: "#2D72FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2069.39 1417H1894.11V1431H2069.39V1417Z",
    fill: "#2D72FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2266.31 1417H2088.34V1431H2266.31V1417Z",
    fill: "#2D72FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2460.48 1417H2285.2V1431H2460.48V1417Z",
    fill: "#2D72FE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2479.31 1417H2649.2C2652.18 1417 2654.59 1420.14 2654.59 1424C2654.59 1427.87 2652.18 1431 2649.2 1431H2479.31V1417Z",
    fill: "#2D72FE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1705.39 1551.01H1875.28V1565.01H1705.39C1702.41 1565.01 1700 1561.87 1700 1558.01C1700 1554.14 1702.41 1551.01 1705.39 1551.01Z",
    fill: "#2D72FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2069.39 1551.01H1894.11V1565.01H2069.39V1551.01Z",
    fill: "#2D72FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2266.31 1551.01H2088.34V1565.01H2266.31V1551.01Z",
    fill: "#2D72FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2460.48 1551.01H2285.2V1565.01H2460.48V1551.01Z",
    fill: "#2D72FE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2479.31 1551.01H2649.2C2652.18 1551.01 2654.59 1554.14 2654.59 1558.01C2654.59 1561.87 2652.18 1565.01 2649.2 1565.01H2479.31V1551.01Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1282.06 310C1330.71 310 1370.98 345.805 1377.98 392.497C1393.53 449.787 1413.8 578.616 1393.12 598.823H1262.29L1262.26 598.129C1213.76 592.764 1176.05 551.651 1176.05 501.729V406.992C1176.05 353.425 1219.47 310 1273.04 310H1282.06Z",
    fill: "#4A312C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1361.66 369.252C1387.8 417.978 1384.69 541.578 1350.91 550.287C1337.43 553.76 1308.73 545.253 1279.52 527.646L1297.85 657.369H1189.58L1226.85 483.637C1206.07 459.237 1192 429.335 1194.35 395.83C1201.12 299.286 1335.52 320.525 1361.66 369.252Z",
    fill: "#B28B67"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1275.3 314.512C1327.54 314.512 1344.03 338.82 1358.07 359.458C1347.57 395.482 1306.83 400.823 1270.63 423.278C1266.36 419.81 1260.92 417.732 1255 417.732C1241.29 417.732 1230.18 428.84 1230.18 442.544C1230.18 456.247 1241.29 467.356 1255 467.356C1255.37 467.356 1255.75 467.347 1256.13 467.33C1261.11 520.915 1259.11 582.108 1244.25 596.634H1113.42C1106.13 469.986 1176.58 519.03 1176.58 399.787C1180.97 395.497 1185.12 391.25 1189.23 387.587L1189.08 384.079C1211.74 337.701 1240.48 314.512 1275.3 314.512Z",
    fill: "#4A312C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1153.49 1031.8L1318.74 1601.25L1396.47 2028.8H1474.48L1396.61 1031.8H1153.49Z",
    fill: "#B28B67"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1153.49 1031.8L1318.74 1601.25L1396.47 2028.8H1474.48L1396.61 1031.8H1153.49Z",
    fill: "black",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1079.23 1031.8C1090.76 1327.63 1086.21 1488.98 1083.63 1515.86C1081.05 1542.73 1066.4 1722.74 966.565 2037.82H1047.71C1179.92 1735.55 1226.08 1555.55 1241.24 1515.86C1256.41 1476.16 1301.19 1314.81 1366.58 1031.8H1079.23Z",
    fill: "#B28B67"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1149.94 1031.8C1192.93 1227.75 1267.27 1540.53 1372.98 1970.15H1487.08C1495.51 1529.19 1459.66 1238.96 1397.57 1031.8H1149.94Z",
    fill: "#DDE3E8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1078.65 1031.8C1089.94 1327.63 1060.67 1619.07 970.019 1974.76H1091.76C1224.22 1677 1319.16 1386.99 1384.04 1031.8H1078.65Z",
    fill: "#DDE3E8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M907.807 898.158L987.256 912.543C895.046 1095.52 845.658 1192.27 839.092 1202.79C824.32 1226.46 839.232 1269.09 844.859 1291.59C812.168 1299.8 824.25 1250.16 782.893 1261.2C745.143 1271.28 713.419 1296.01 677.497 1264.03C673.08 1260.1 669.68 1247.63 684.387 1240.95C721.028 1224.3 775.051 1193.37 783.693 1181.58C795.477 1165.51 836.849 1071.03 907.807 898.158ZM1559.01 942.172L1702.91 1047.84C1741.94 1058.37 1774.55 1071.48 1800.74 1087.15C1806.92 1092.79 1814.4 1104.2 1788.75 1102.23C1763.09 1100.26 1736.02 1099.34 1732.48 1108.09C1728.94 1116.84 1744.46 1127.3 1737.31 1139.1C1732.54 1146.98 1710 1127.24 1669.7 1079.9L1527.2 1020.81L1559.01 942.172Z",
    fill: "#B28B67"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1299.05 567.33C1366.31 706.355 1457.33 839.732 1592.54 953.664C1611.06 952.332 1631.2 955.399 1652.78 962.673C1663.41 966.253 1669.12 977.768 1665.54 988.393C1663.46 994.563 1658.71 999.076 1653 1001.07C1657.13 1004.09 1661.3 1007.09 1665.51 1010.07L1629.2 1084.18C1476.44 1008.01 1332.85 950.583 1267.42 824.834C1245.47 782.63 1252.9 639.271 1250.8 587.117L1299.05 567.33Z",
    fill: "#C5CFD6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1081.31 1072C1223.14 1087.58 1334.77 1087.58 1416.21 1072C1426.3 1070.07 1425.86 1026.57 1421.18 1014.69C1348.31 829.708 1300.38 694.289 1300.38 565.802C1287.01 572.786 1263.61 573.832 1230.18 568.942C1140.35 701.352 1099.05 853.278 1081.31 1072Z",
    fill: "#191847"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1245.29 558.12C1230.19 757.883 1438.83 1194.01 1366.39 1566.47C1232.48 1596.38 1041.31 1503.34 855.223 1577.67C862.148 1427.67 1000.85 1251.46 1054.97 1093.86C1050.15 1089.34 1047.64 1082.54 1048.87 1075.54L1051.22 1062.22C1052.81 1053.19 1060.14 1046.61 1068.8 1045.58C1070.32 1038.82 1071.63 1032.09 1072.71 1025.41C1081.81 969.042 1066.26 913.768 1066.98 859.488C994.443 921.376 929.367 1028.25 871.758 1180.09L786.554 1155.02C789.806 1142.94 793.174 1131.01 796.659 1119.23C786.828 1113.66 775.329 1088.04 783.601 1083.76C792.141 1079.33 801.189 1076.22 810.716 1074.38C888.842 839.081 1016.6 666.992 1193.99 558.12L1245.29 558.12Z",
    fill: "#C5CFD6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1212.62 562.632L1189.35 634.205L1236.22 687.861L1193.86 730.025L1296.33 905.489L1171.02 730.376L1212.62 687.861L1171.02 640.444L1212.62 562.632Z",
    fill: "black",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1293.34 1144.59C1303.31 1144.59 1311.39 1152.67 1311.39 1162.63C1311.39 1172.6 1303.31 1180.68 1293.34 1180.68C1283.38 1180.68 1275.3 1172.6 1275.3 1162.63C1275.3 1152.67 1283.38 1144.59 1293.34 1144.59ZM1288.83 1040.83C1298.8 1040.83 1306.88 1048.91 1306.88 1058.87C1306.88 1068.84 1298.8 1076.92 1288.83 1076.92C1278.86 1076.92 1270.79 1068.84 1270.79 1058.87C1270.79 1048.91 1278.86 1040.83 1288.83 1040.83ZM1266.27 937.067C1276.24 937.067 1284.32 945.146 1284.32 955.112C1284.32 965.079 1276.24 973.158 1266.27 973.158C1256.31 973.158 1248.23 965.079 1248.23 955.112C1248.23 945.146 1256.31 937.067 1266.27 937.067Z",
    fill: "black",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1788.5 235.02L1807.29 280.201L1808.46 283.021L1811.51 283.265L1860.29 287.175L1823.12 319.009L1820.8 320.996L1821.51 323.967L1832.87 371.565L1791.11 346.058L1788.5 344.466L1785.89 346.058L1744.13 371.565L1755.49 323.967L1756.2 320.996L1753.88 319.009L1716.71 287.175L1765.49 283.265L1768.54 283.021L1769.71 280.201L1788.5 235.02Z",
    stroke: "#2D72FE",
    strokeWidth: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3200,
    height: 1800,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeadershipCompetencies);
export default __webpack_public_path__ + "static/media/leadership-competencies.8a0974ccdeda6ede041ed9ffe54a4f12.svg";
export { ForwardRef as ReactComponent };